import AppConfig from "config";
import React, { useState, useEffect } from 'react';
import {
  Table,
  Tbody,
  Text,
  Th,
  Thead,
  Tr,
  Td,
  Flex,
  Box,
  Button,
  Input,
  InputGroup,
  InputRightElement,
  IconButton,
  Spinner,
  useDisclosure,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Divider,
  Checkbox,
  Stack,
  useToast
} from '@chakra-ui/react';
import { SearchIcon } from '@chakra-ui/icons';
import Card from 'components/Card/Card.js';
import CardBody from 'components/Card/CardBody.js';
import CardHeader from 'components/Card/CardHeader.js';
import { useParams } from 'react-router-dom';
import TranscriptController from './controllers/TranscriptController';
import TranscriptsController from "controllers/Transcripts/TranscriptsController";
import SingleTranscriptController from "../Audios/controllers/SingleAudioController";

function TranscriptsView2({ openTab }) {
  const [data, setData] = useState([]);
  const [originalData, setOriginalData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [searchId, setSearchId] = useState('');
  const { Audit_id } = useParams();
  const [currentPage, setCurrentPage] = useState(1);
  const [selectedIds, setSelectedIds] = useState([]);
  const { isOpen: isConfirmOpen, onOpen: onConfirmOpen, onClose: onConfirmClose } = useDisclosure();
  const toast = useToast();

  const goToNextPage = async () => {
    try {
      setCurrentPage((prevPage) => Math.max(1, prevPage + 1));
      const jwtToken = localStorage.getItem('access_token');
      const nextPageData = await TranscriptController.listTranscripts(jwtToken, currentPage + 1);
      setData(nextPageData);
      setOriginalData(nextPageData);
      setFilteredData(nextPageData);
    } catch (error) {
      console.error('Error fetching next page data:', error);
    }
  };

  const goToPreviousPage = async () => {
    try {
      setCurrentPage((prevPage) => Math.max(1, prevPage - 1));
      const jwtToken = localStorage.getItem('access_token');
      const nextPageData = await TranscriptController.listTranscripts(jwtToken, currentPage - 1);
      setData(nextPageData);
      setOriginalData(nextPageData);
      setFilteredData(nextPageData);
    } catch (error) {
      console.error('Error fetching previous page data:', error);
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const jwtToken = localStorage.getItem('access_token');
        const profiles = await TranscriptController.listTranscripts(jwtToken);
        setData(profiles);
        setOriginalData(profiles);
        setFilteredData(profiles);
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };
    fetchData();
  }, [Audit_id]);

  const handleSearch = async () => {
    try {
      if (searchId.trim() === '') {
        const jwtToken = localStorage.getItem('access_token');
        const profiles = await TranscriptController.listTranscripts(jwtToken);
        setData(profiles);
        setOriginalData(profiles);
        setFilteredData(profiles);
        setCurrentPage(1)
      } else {
        const filtered = await TranscriptsController.listTranscriptsSearch(searchId);
        setFilteredData(filtered);
        setCurrentPage(1)
      }
    } catch (error) {
      console.error('Error searching data:', error);
    }
  };

  const toggleSelectTranscript = (id) => {
    setSelectedIds(prevIds =>
      prevIds.includes(id) ? prevIds.filter(prevId => prevId !== id) : [...prevIds, id]
    );
  };

  const handleDeleteSelected = async () => {
    if (selectedIds.length === 0) {
      toast({
        title: "Nenhuma transcrição selecionada.",
        description: "Por favor, selecione pelo menos uma transcrição para deletar.",
        status: "warning",
        duration: 5000,
        isClosable: true,
      });
      return;
    }

    try {
      const jwtToken = localStorage.getItem('access_token');
      const response = await fetch(AppConfig.BACKEND_URL_REFATORADO + `transcripts_page/delete_transcriptions`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${jwtToken}`
        },
        body: JSON.stringify({ transcript_id: selectedIds })
      });

      if (!response.ok) {
        throw new Error('Network response was not ok');
      }

      const updatedData = data.filter(transcript => !selectedIds.includes(transcript.idtranscripts));
      setData(updatedData);
      setOriginalData(updatedData);
      setFilteredData(updatedData);
      setSelectedIds([]);

      toast({
        title: "Transcrições deletadas.",
        description: "As transcrições selecionadas foram deletadas com sucesso.",
        status: "success",
        duration: 5000,
        isClosable: true,
      });

      onConfirmClose();
    } catch (error) {
      console.error('Error deleting transcripts:', error);

      toast({
        title: "Erro ao deletar transcrições.",
        description: "Houve um erro ao tentar deletar as transcrições. Por favor, tente novamente.",
        status: "error",
        duration: 5000,
        isClosable: true,
      });
    }
  };


  return (
    <Flex direction="column" pt={{ base: '120px', md: '2px' }} overflowY="auto" width="100%">
      <Card overflowX={{ sm: 'scroll', xl: 'hidden' }}>
        <CardHeader p="6px 0px 22px px">
          <Flex flexDirection="column" mb={4}>
            <Box mt={4}>
              <InputGroup width="1030px">
                <Input
                  type="text"
                  value={searchId}
                  onChange={(e) => setSearchId(e.target.value)}
                  variant="filled"
                  _placeholder={{ color: 'gray.400' }}
                  placeholder="Procurar por ID ou Nome da Ficha"
                  borderRadius="md"
                  py={2}
                  px={4}
                  mb={2}
                />
                <InputRightElement width="4.5rem">
                  <IconButton
                    h="1.75rem"
                    size="sm"
                    onClick={handleSearch}
                    icon={<SearchIcon />}
                  />
                </InputRightElement>
              </InputGroup>
            </Box>
            <Flex justifyContent="space-between" alignItems="center">
              <Button size="sm" onClick={goToPreviousPage} mr={2}>
                Página anterior
              </Button>
              <Text>
                Página: {currentPage}
              </Text>
              <Button size="sm" onClick={goToNextPage} ml={2}>
                Próxima página
              </Button>
              <Button size="sm" onClick={onConfirmOpen} ml={2} colorScheme="red" isDisabled={selectedIds.length === 0}>
                Deletar Transcrições
              </Button>
            </Flex>
          </Flex>
        </CardHeader>
        <CardBody>
          <Table variant="simple" size="md">
            <Thead>
              <Tr>
                <Th width="40px">Selecionar</Th>
                <Th width="40px">ID</Th>
                <Th width="40px">Carregar Àudio</Th>
                <Th width="100px">Data</Th>
                <Th width="30px">Ficha</Th>
                <Th width="30px">Palavras mais utilizadas</Th>
              </Tr>
            </Thead>
            <Tbody>
              {filteredData.map((transcript) => (
                <TranscriptsRow
                  key={transcript.idtranscripts}
                  transcript={transcript}
                  openTab={openTab}
                  toggleSelectTranscript={toggleSelectTranscript}
                  isSelected={selectedIds.includes(transcript.idtranscripts)}
                />
              ))}
            </Tbody>
          </Table>
          <Modal isOpen={isConfirmOpen} onClose={onConfirmClose}>
            <ModalOverlay />
            <ModalContent>
              <ModalCloseButton />
              <ModalBody>
                <Text>Tem certeza de que deseja deletar as transcrições selecionadas?</Text>
              </ModalBody>
              <ModalFooter>
                <Button onClick={onConfirmClose} borderRadius="lg" marginRight={2}>
                  Cancelar
                </Button>
                <Button colorScheme="blue" onClick={handleDeleteSelected} borderRadius="lg">
                  Confirmar
                </Button>
              </ModalFooter>
            </ModalContent>
          </Modal>
        </CardBody>
      </Card>
      <Flex flex={1} justifyContent="center">
      </Flex>
    </Flex>
  );
}

function TranscriptsRow({
  transcript,
  openTab,
  isSelected,
  toggleSelectTranscript
}) {
  const [isExpanded, setIsExpanded] = useState(false);
  const [audioUrl, setAudioUrl] = useState('');
  const [loading, setLoading] = useState(false);
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [vadFilter, setVadFilter] = useState(false);
  const [repenaltyFilter, setrepenaltyFilter] = useState(false);

  const handleConversar = (idtranscripts) => {
    openTab('tab2', idtranscripts);
  };

  const handleRetranscript = () => {
    onOpen();
  };

  const handleRetranscription = async () => {
    try {
      const jwtToken = localStorage.getItem('access_token');
      const nextPageData = await TranscriptController.AddToRetranscript(jwtToken, transcript.idtranscripts, vadFilter ? 'True' : 'False', repenaltyFilter ? 2 : 1);
      console.log(nextPageData);
      onClose();
    } catch (error) {
      console.error('Error fetching next page data:', error);
    }
  };

  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString('pt-BR');
  };

  const toggleExpand = () => {
    setIsExpanded((prevState) => !prevState);
  };

  const getDisplayText = () => {
    const maxLines = 2;
    const lines = transcript.transcript_text.split('\n');
    if (isExpanded || lines.length <= maxLines) {
      return transcript.transcript_text;
    }
    return lines.slice(0, maxLines).join('\n') + ' ...';
  };

  const fetchAudio = async () => {
    setLoading(true);
    try {
      const audioUrl = await SingleTranscriptController.getAudio(transcript.idtranscripts);
      if (audioUrl) {
        setAudioUrl(audioUrl);
      } else {
        console.error('Error fetching audio: No data returned');
      }
    } catch (error) {
      console.error('Error fetching audio:', error);
    }
    setLoading(false);
  };

  return (
    <>
      <Tr>
        <Td>
          <Checkbox isChecked={isSelected} onChange={() => toggleSelectTranscript(transcript.idtranscripts)} />
        </Td>
        <Td style={{ verticalAlign: 'top' }}>{transcript.idtranscripts}</Td>
        <Td style={{ verticalAlign: 'top' }}>
          {loading ? (
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <Spinner size="sm" />
              <span style={{ marginLeft: '8px' }}>Carregando...</span>
            </div>
          ) : audioUrl ? (
            <audio controls>
              <source src={audioUrl} type="audio/mp3" />
              Your browser does not support the audio element.
            </audio>
          ) : (
            <svg title="Acessar áudio." size="sm" onClick={fetchAudio} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-play">
              <polygon points="5 3 19 12 5 21 5 3"></polygon>
            </svg>
          )}
        </Td>
        <Td style={{ verticalAlign: 'top' }}>
          {formatDate(transcript.date_start)}
        </Td>
        <Td style={{ verticalAlign: 'top' }}>{transcript.audit_nome}</Td>
        <Td style={{ verticalAlign: 'top' }}>{transcript.word_cloud}</Td>
      </Tr>
      <Tr>
        <Td style={{ verticalAlign: 'top', whiteSpace: 'pre-line' }} colSpan={4}>
          {getDisplayText()}
          <br />
          <b>Metadados</b>
          <br />
          <b>Metadados csv: </b>
          {transcript.extracted_csv}
          <br />
          <b>Metadados pdf: </b>
          {transcript.extracted_pdf}
          <br />
          <b>Metadados jpg: </b>
          {transcript.extracted_jpg}
        </Td>
        <Td colSpan={6} textAlign="center" verticalAlign="top">
          <Flex justify="center" align="center">
            <Button size="sm" onClick={toggleExpand} style={{ marginRight: '10px' }}>
              {isExpanded ? 'Recolher' : 'Expandir'}
            </Button>
            <Button size="sm" style={{ marginRight: '10px' }} onClick={() => handleConversar(transcript.idtranscripts)}>
              Conversar
            </Button>
            <Button size="sm" style={{ marginRight: '10px' }} onClick={handleRetranscript}>
              Retranscrição
            </Button>
          </Flex>
        </Td>
      </Tr>
      <Modal isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />
        <ModalContent>
          <ModalCloseButton />
          <ModalBody>
            <Box textAlign="left" py={4}>
              <Text>Escolhendo os itens abaixo, a transcrição</Text>
              <Text>será refeita com parâmetros diferentes</Text>
              <Divider my={4} />
              <Text color="blue.500" mt={2}>Seleciona um ou mais erros</Text>
              <Stack spacing={3} mt={5}>
                <Checkbox isChecked={vadFilter} onChange={(e) => setVadFilter(e.target.checked)}>Pulou texto</Checkbox>
                <Checkbox>Errou Palavras Importantes</Checkbox>
                <Checkbox isChecked={repenaltyFilter} onChange={(e) => setrepenaltyFilter(e.target.checked)}>Gerou trechos repetidos (alucinação)</Checkbox>
              </Stack>
              <Divider my={4} />
            </Box>
          </ModalBody>
          <ModalFooter>
            <Flex justify="flex-end">
              <Button onClick={onClose} borderRadius="lg" marginRight={2}>Cancelar</Button>
              <Button colorScheme="blue" onClick={handleRetranscription} borderRadius="lg">Retranscrever</Button>
            </Flex>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
}

export default TranscriptsView2;